import { Injectable, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events.enum';
import { MarginNotesStore } from './margin-notes.store';

@Injectable({ providedIn: 'root' })
export class MarginNotesReducer {
    private readonly eventBus = inject(EventBusService);
    private readonly marginNotesStore = inject(MarginNotesStore);
    private readonly destroy$ = inject(DestroyRef);

    constructor() {
        this.listenToMarginNotesEvent();
        this.listenToLoadMarginDetailsEvent();
    }

    private listenToLoadMarginDetailsEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_LOAD_MARGIN_DETAILS)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginNotesStore.updateMarginNotes(event.payload.marginDetails.marginNotes);
            });
    }

    private listenToMarginNotesEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.MARGIN_NOTES_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                const value = event.payload?.marginNotes as string | undefined;
                this.marginNotesStore.updateMarginNotes({ marginNotes: value });
            });
    }
}
